import CryptoJS from 'crypto-js'

const SECRET_KEY = 'N2YUN_YxbEdAemrXMDcuyb83mZ_VERIFY'

export function encrypt(text) {
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString()
}

export function decrypt(text) {
    const bytes = CryptoJS.AES.decrypt(text, SECRET_KEY)

    return bytes.toString(CryptoJS.enc.Utf8)
}